// API names for external API configurations
export const API_NAMES = {
    DATASHARING: 'datasharing',
    ACTIVITY_SERVICE: 'activity-service',
} as const;

export type ApiName = typeof API_NAMES[keyof typeof API_NAMES];
